import codes from '@/codes';

//restful api
import { detect, result, system } from '@/service/api/wmds'

const i18n_detect = {
  EN: [
    { key: 'created_at', label: 'Detect_at', sortable: false, thStyle: 'width: 15%' },
    { key: 'domain', label: 'Site', sortable: false, thStyle: 'width: 15%' },
    { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 25%' },
  ],
  KO: [
    { key: 'created_at', label: '탐지 날짜', sortable: false, thStyle: 'width: 15%' },
    { key: 'domain', label: '사이트', sortable: false, thStyle: 'width: 15%' },
    { key: 'type', label: '타입', sortable: false, thStyle: 'width: 25%' },
  ]
}

const i18n_result = {
  EN: [
    { key: 'finished_at', label: 'Finished_at', sortable: false, thStyle: 'width: 15%' },
    { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 15%' },
    { key: 'count', label: 'Count(Pages, External, Detect, Binary, Error)', sortable: false, thStyle: 'width: 25%' },
  ],
  KO: [
    { key: 'finished_at', label: '종료 날짜', sortable: false, thStyle: 'width: 15%' },
    { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 15%' },
    { key: 'count', label: '횟수(Pages, External, Detect, Binary, Error)', sortable: false, thStyle: 'width: 25%' },
  ]
}

export default {
  computed : {
    f_detect : function() {
      return i18n_detect[this.i18n];
    },
    f_result() {
      return i18n_result[this.i18n];
    },
  },
  data : () => {
    return {
      codes,
      sync : { th : undefined, stop : false, interval : 15 },
      detect : {},
      result : {},
      pattern : {},
      model : { result : { so : undefined, rows : [] }, detect : { so : undefined, rows : [] } },
      so : { offset : 0, currentPage : 1, target : '', cmd : '', totalRows : 0, limit : 15, body : { and : [], sort : [{ name : "id", op : "desc" } ], columns : [] }, },
    }
  },
  methods: {
    refresh(t = '') {
      location.hostname == 'localhost' ? console.log(t, this.result.th, this.detect.th) : '';
      if(t === '') {
        if(!this.result.th) { this.result.th = setTimeout(() => this.refresh('result'), this.result.interval * 1000); }
        if(!this.detect.th) { this.detect.th = setTimeout(() => this.refresh('detect'), this.detect.interval * 1000); }
      } else if(t == 'result') {
        if(!this.result.stop && this.$refs._list_result) { this.$refs._list_result.refresh(); }
        if(this.result.th) {  clearTimeout(this.result.th); this.result.th = undefined }
        this.result.th = setTimeout(() => this.refresh('result'), this.result.interval * 1000)
      } else {
        if(!this.detect.stop && this.$refs._list_detect) { this.$refs._list_detect.refresh(); }
        if(this.detect.th) { clearTimeout(this.detect.th); this.detect.th = undefined }
        this.detect.th = setTimeout(() => this.refresh('detect'), this.detect.interval * 1000)
      }
      console.log("request refresh", t == '' ? "init" : t)
      // interval 15 secs
    },
    pause(rs) {
      if(rs == 'result')
      {
        this.result.stop = !this.result.stop;
        console.log("refresh", "result", this.result.stop ? 'update.stop' : 'update.continue');
      } else {
        this.detect.stop = !this.detect.stop;
        console.log("refresh", "detect", this.detect.stop ? 'update.stop' : 'update.continue');
      }
      this.refresh(rs)

    },
    rowHighlight(item) {
      if (!item || !item.level) return '';
      if (item.detect_count > 0) return 'table-danger';

      switch (codes.WMDS_TYPE[item.level]) {
        case 'danger' : return 'table-danger';
        case 'warning' :
        case 'suspicion' :
        case 'caution' : return 'table-warning';
        default : return '';
      }
    },
    getPattern() {
      // recent system pattern
      let so = Object.assign({}, this.so, { columns : ["code", "type", "created_at"]})
      system.listSys(so).then(rs => { this.pattern = rs.body ? rs.body[0] : ''; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    getDetect() {
      // detect
      let so = Object.assign({}, this.model.detect.so)
      so.body.columns = ["id", "domain", "level", "type", "created_at"]
        return detect.listDetect(so).then(rs => {
        this.model.detect.so.totalRows = rs.total;
        location.hostname == 'localhost' ? console.log("refresh detect done") : '';
        return rs.body
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    getResult() {
      // result
      let so = Object.assign({}, this.model.result.so)
      so.body.columns = ["id", "page_count", "detect_count", "ext_count", "error_count", "binary_count", "resource_count",  "created_at"]
        return result.listResult(so).then(rs => {
        this.model.result.so.totalRows = rs.total;
        location.hostname == 'localhost' ? console.log("refresh result done") : '';
        return rs.body
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item){
      this.$router.push({ name : 'wmds_detect', params : { id: item.id } })
    },
  },
  created: function() {
    this.model.result.so =  Object.assign({}, this.so);
    this.model.detect.so =  Object.assign({}, this.so);
    this.result = Object.assign({}, this.sync);
    this.detect = Object.assign({}, this.sync);
    console.log('dashboard.vue', 'created');

  },
  destroyed: function() {
    clearTimeout(this.result.th);
    this.result.th = undefined;
    clearTimeout(this.detect.th);
    this.detect.th = undefined;
    console.log('dashboard.vue', 'destroyed');
  },
  mounted: function() { console.log('dashboard.vue', 'mounted'); this.getPattern(); this.refresh(''); },
}